const state = {
    stores: [],
    store: {},
    error: null
};

export default state;
